<template>
  <ProductPageLayout
    name="芊荨搜索文件文本"
    :logo="logo"
    :hero-image="heroImage"
    lead="更快、更准的 Windows 文件搜索工具：文件名秒搜与文件内容检索一体，毫秒级定位目标文件。"
    :feature-lines="featureLines"
    download-link="/ftp/packages/searchfile/SearchfileSetup.exe"
    download-file-name="SearchfileSetup.exe"
    :meta-items="metaItems"
    :detailed-features="detailedFeatures"
    :other-features="otherFeatures"
    :reviews="reviews"
    features-desc="文件名检索与内容搜索双引擎，多视图浏览与收藏夹管理，让找文件更高效。"
    other-desc="覆盖日常找文件、读文本、整理目录等高频场景。"
    reviews-desc="真实反馈持续驱动搜索体验与效率优化。"
  />
</template>

<script>
import ProductPageLayout from '@/components/ProductPageLayout.vue'

export default {
  name: 'Searchfile',
  components: { ProductPageLayout },
  data() {
    return {
      logo: require('@/assets/searchfile/searchfile_48x48.png'),
      heroImage: require('@/assets/searchfile/文件名搜索-详细视图.png'),
      featureLines: [
        '文件名搜索 / 内容搜索替换 / 路径过滤 / 快速定位',
        '列表模式 / 图标模式 / 收藏夹 / 右键快捷操作'
      ],
      metaItems: [
        { icon: 'fast', label: '毫秒响应' },
        { icon: 'search', label: '内容检索' },
        { icon: 'image', label: '多视图管理' }
      ],
      detailedFeatures: [
        {
          title: '文件名极速搜索',
          brief: '全盘索引，关键字一出结果就到。',
          detail: '依托高效索引机制，面对海量文档、媒体与项目目录，仍能保持接近实时的文件名检索体验。',
          image: require('@/assets/searchfile/文件名搜索-列表模式.png')
        },
        {
          title: '文件内容搜索与替换',
          brief: '在文本、代码与配置中定位关键字，并支持批量替换。',
          detail: '支持按目录范围、文件类型与编码扫描内容，预览命中行后可进一步完成查找替换，适合日志排查与工程维护。',
          image: require('@/assets/searchfile/内容搜索.png')
        },
        {
          title: '多视图浏览',
          brief: '列表、详细与图标模式自由切换。',
          detail: '在信息密集的列表视图与直观的图标预览之间快速切换，兼顾文档管理与素材检视两类需求。',
          image: require('@/assets/searchfile/文件名搜索-中图标.png')
        },
        {
          title: '收藏夹管理',
          brief: '常用路径统一归档，一键直达。',
          detail: '可将常用文件夹、项目路径或工具入口加入收藏，减少重复跳转，提高日常处理效率。',
          image: require('@/assets/searchfile/收藏夹.png')
        }
      ],
      otherFeatures: [
        { title: '路径过滤', description: '按目录与关键字组合过滤，结果更精准。', icon: 'pin' },
        { title: '右键快捷菜单', description: '从资源管理器快速触发搜索与定位。', icon: 'mouse' },
        { title: '本地处理', description: '检索与替换均在本机完成，数据不上传。', icon: 'lock' },
        { title: '轻量稳定', description: '面向长期日常使用，界面克制、启动轻快。', icon: 'fast' }
      ],
      reviews: [
        { name: '郭工程师', comment: '日志和配置文件查找效率提升很大，内容搜索定位问题非常快。', avatar: require('@/assets/searchfile/avatar1.jpg') },
        { name: '郑老师', comment: '教学资料太多时，关键词搜索能马上找到对应课件。', avatar: require('@/assets/searchfile/avatar2.jpg') },
        { name: '潘同学', comment: '写论文时找素材方便很多，不用在目录里来回翻。', avatar: require('@/assets/searchfile/avatar3.jpg') },
        { name: '戴运营', comment: '活动素材管理更清晰，图标模式预览很实用。', avatar: require('@/assets/searchfile/avatar4.jpg') },
        { name: '程产品', comment: '搜索速度稳定，收藏夹让常用目录管理轻松了不少。', avatar: require('@/assets/searchfile/avatar5.jpg') },
        { name: '方设计', comment: '图片素材查找很顺畅，交付过程节省很多时间。', avatar: require('@/assets/searchfile/avatar6.jpg') }
      ]
    }
  }
}
</script>
